<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">© 2007 Academy Chicago Publishers</span></p>
<p class="P_Normal__And__Centre_Alignment"> </p>
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">Published in 2007 by </span></p>
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">Academy Chicago Publishers</span></p>
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">363 West Erie Street, 4W</span></p>
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">Chicago, Illinois 60654</span></p>
<p class="P_Normal__And__Centre_Alignment"> </p>
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">First published in 1930</span></p>
<p class="P_Normal__And__Centre_Alignment"> </p>
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">Printed and bound in the U.S.A.</span></p>
<p class="P_Normal__And__Centre_Alignment"> </p>
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">All rights reserved.</span></p>
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">No part of this book may be reproduced in any form </span></p>
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">without the express written permission of the publisher.</span></p>
<p class="P_Normal__And__Centre_Alignment"> </p>
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">Library of Congress data on file with publisher.</span></p>
<p class="P_Normal__And__Centre_Alignment"><span style=" font-family: Georgia; font-size: 0.83em;">eBook ISBN: 978-0-89733-662-8</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0002.vue?5c209240